import { motion } from 'framer-motion'

const AnimatedDiv = ({
    children,
    duration = 0.6,
    right
}: {
    children: React.ReactElement | string,
    duration?: number,
    right?: boolean
}) => {
    return (
        <>
            <div className="hidden">
                {children}
            </div>
            <motion.div
                initial={{ opacity: 0, ...(right ? { x: 20 } : { y: 20 }) }}
                animate={{ opacity: 1, x: 0, y: 0 }}
                exit={{ opacity: 0, ...(right ? { x: -20 } : { y: -20 }) }}
                transition={{ duration }}
            >
                {children}
            </motion.div>
        </>
    )
}

export default AnimatedDiv;